module.exports = __webpack_public_path__ + "img/banner.765b5620.png";